import { Linking } from "react-native";
import {
  addNotificationResponseReceivedListener,
  clearLastNotificationResponseAsync,
} from "expo-notifications";
import { useCallback } from "react";
import { usePushNotificationPayloadStore } from "@src/stores/pushNotificationPayload";
import type { ConcreteOptions } from "./types";

/**
 * Handle any new links triggered while app is already open
 *
 * @link https://docs.expo.dev/linking/into-your-app/#handle-urls
 * @link https://docs.expo.dev/versions/latest/sdk/notifications/#handle-push-notifications-with-navigation
 */
export const useSubscribe = () => {
  const setPayloadFromNotificationResponse = usePushNotificationPayloadStore(
    state => state.setPayloadFromNotificationResponse
  );

  const subscribe: ConcreteOptions["subscribe"] = useCallback(
    (listener: (url: string) => void) => {
      const linkingSubscription = Linking.addEventListener("url", event => {
        listener(event.url);
      });

      const expoNotificationsSubscription = addNotificationResponseReceivedListener(response => {
        setPayloadFromNotificationResponse(response);
        clearLastNotificationResponseAsync();
      });

      return () => {
        linkingSubscription.remove();
        expoNotificationsSubscription.remove();
      };
    },
    [setPayloadFromNotificationResponse]
  );

  return { subscribe };
};
